
















import {
  Vue,
  Component,
  VModel,
  Prop,
  Emit,
  Watch,
} from "vue-property-decorator";
import FuzzySearch from "@/components/fuzzysearch/FuzzySearch.vue";
import { AXIOS, Request } from "@/utility/api.ts";
import { StringUtils } from "@/utility/utils.ts";

@Component({
  components: {
    FuzzySearch,
  },
})
export default class EmployeeFuzzySearch extends Vue {
  @VModel({ type: String }) employee!: string;
  @Prop(String) propLabel!: string;
  @Prop(String) propUrl!: boolean;
  @Prop(Boolean) propHasNtAccount!: boolean;
  @Prop(Boolean) propHasEmpCode!: boolean;
  @Prop(Boolean) propHasEmpName!: boolean;

  protected entries: Array<any> = [];
  protected items: Array<any> = [];
  protected isLoading = false;
  protected search = "";

  private getItem(
    x: any,
    hasNtAccount: boolean,
    hasEmpName: boolean,
    hasEmpCode: boolean
  ) {
    let result = "";
    if (hasNtAccount) result = `${x.ntAccount.trim()}`;
    if (hasEmpName) result = `${result} ${x.empName.trim()}`;
    if (hasEmpCode) result = `${result} ${x.empCode.trim()}`;
    return result;
  }

  private updateItems() {
    this.items = this.entries.map((x) => {
      return this.getItem(
        x,
        this.propHasNtAccount,
        this.propHasEmpName,
        this.propHasEmpCode
      );
    });
  }

  private updateEntries(value: string) {
    if (value) {
      this.isLoading = true;

      // Lazily load input items
      AXIOS.get(Request, `${this.propUrl}${value}`, {})
        .then((res) => {
          let employeeList = res.data.data;
          this.entries = !employeeList ? [] : employeeList;

          this.updateSelect(value);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    }
  }

  @Emit("updateSelect")
  updateSelect(value: string) {
    const user = this.entries.filter(
      (x) =>
        StringUtils.toUpperTrim(x.ntAccount) === StringUtils.toUpperTrim(value)
    )[0];
    if (!user) return "";
    return {
      empCode: user.empCode,
      userName: user.empName,
      ntAccount: user.ntAccount,
    };
  }
}
